import grey from '@material-ui/core/colors/grey';
import red from '@material-ui/core/colors/red';
import createMuiTheme from "@material-ui/core/es/styles/createMuiTheme";
const grey900 = grey['900'];
const red500 = red['500'];

const primaryColor = '#216CEB';
const primaryShadow = '0 12px 20px -10px #216ceb57, 0 4px 20px 0px rgba(0, 0, 0, 0.12), 0 7px 8px -5px #216ceb52';
const primarySmallShadow = '0 2px 2px 0 #216ceb2e, 0 3px 1px -2px #3175e854, 0 1px 5px 0 #216ceb24';
const primaryBackground = 'linear-gradient(60deg, #216ceb, #1b5ece)';

export default createMuiTheme({
    palette: {
        primary: {
            main: primaryColor
        },
        secondary: {
            main: red500,
        },
    },
    button: {
        shadows: {
            primary: primaryShadow,
            primarySmall: primarySmallShadow
        }
    },
    sideBar: {
      shadows: {
          primary: primaryShadow
      }
    },
    appBar: {
        height: 57,
        color: primaryColor
    },
    drawer: {
        width: 230,
        color: grey900
    },
    raisedButton: {
        primaryColor: primaryColor,
    },
    toolbar: {
        height: 160
    },
    cardHeader: {
        primary: {
            background: primaryBackground,
            boxShadow: primaryShadow
        }
    },
    shape: {
        borderRadius: "1px"
    }
});





// WEBPACK FOOTER //
// ./src/bluemail-theme.js